import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Мини-маскот РешAI — плоская 2D-версия «глиняной» модельки: голубой малыш
 * с антенной. Единственный источник знака — навбар, футер, auth-страницы,
 * лоадер маршрута и фавикон. Читается от ~22px. Цвета фиксированные
 * (иллюстрация одинакова в светлой и тёмной теме).
 */
export function BrandMark({ size = 30, className = '' }) {
  return (
    <svg
      width={size}
      height={(size * 150) / 128}
      viewBox="0 0 128 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={cn('shrink-0', className)}
    >
      {/* антенна */}
      <path d="M62 41C60 29 65 20 70 16" stroke="#5F8CE6" strokeWidth="5" strokeLinecap="round" />
      <circle cx="71" cy="15" r="7.6" fill="#8AB2F3" stroke="#3E6FD0" strokeWidth="2.2" />
      {/* руки */}
      <path d="M29 82C15 85 10 99 16 108C21 114 31 107 30 97Z" fill="#6E9CEC" />
      <path d="M99 82C113 85 118 99 112 108C107 114 97 107 98 97Z" fill="#6E9CEC" />
      {/* ноги */}
      <ellipse cx="50" cy="126" rx="13" ry="8" fill="#6E9CEC" />
      <ellipse cx="78" cy="126" rx="13" ry="8" fill="#6E9CEC" />
      {/* тело */}
      <path
        d="M64 34C91 34 109 56 109 84C109 107 90 122 64 122C38 122 19 107 19 84C19 56 37 34 64 34Z"
        fill="#8FB7F4"
        stroke="#3E6FD0"
        strokeWidth="2.4"
      />
      {/* мягкая нижняя тень-животик */}
      <path d="M26 97C36 115 92 115 102 97C98 114 84 122 64 122C44 122 30 114 26 97Z" fill="#6E9CEC" opacity="0.5" />
      {/* брови */}
      <path d="M40.5 49.5Q49 45.5 57.5 48.5" stroke="#18263F" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M70.5 48.5Q79 45.5 87.5 49.5" stroke="#18263F" strokeWidth="3.2" strokeLinecap="round" />
      {/* глаза */}
      <ellipse cx="50" cy="67" rx="9.6" ry="12.4" fill="#18263F" />
      <ellipse cx="78" cy="67" rx="9.6" ry="12.4" fill="#18263F" />
      <circle cx="46.6" cy="62" r="3.3" fill="#FFFFFF" />
      <circle cx="74.6" cy="62" r="3.3" fill="#FFFFFF" />
      {/* улыбка */}
      <path d="M55 87Q64 95 73 87" stroke="#18263F" strokeWidth="3.5" strokeLinecap="round" />
    </svg>
  );
}

/**
 * Полный логотип: знак-маскот + wordmark «РешAI» (Unbounded, «AI» — «Чернила»).
 * Отрицательный правый margin гасит хвостовой трекинг после последней буквы,
 * иначе логотип визуально смещается влево при центрировании.
 */
export function BrandLogo({ markSize = 30, className = '', textClassName = '' }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <BrandMark size={markSize} />
      <span
        className={cn(
          'font-brand font-extrabold tracking-[-0.01em] -mr-[0.01em] leading-none text-foreground',
          textClassName
        )}
      >
        Реш<span className="text-primary">AI</span>
      </span>
    </span>
  );
}
